const GET_RANDOM_QUESTION = 'Get random question'
const FETCHING_QUESTION = 'Fetching question'
const ANSWER_QUESTION = 'Answer question'
const QUESTION_ANSWERED = 'Question answered'
const ADD_MESSAGE_FROM_BACKEND = 'Add message'
const GET_FLAGGED_QUESTIONS = 'Get flagged questions'
const DELETE_QUESTIONS = 'Delete questions'
const UNFLAG_QUESTIONS = 'Unflag questions'
const GET_DELETED_QUESTIONS = 'Get deleted questions'
const RESTORE_QUESTIONS = 'Restore questions'
const GET_AVAILABLE_QUESTIONS = 'Get available questions'
const FETCH_QUESTIONS = 'Fetch questions'

export default {
  GET_RANDOM_QUESTION,
  FETCHING_QUESTION,
  ANSWER_QUESTION,
  QUESTION_ANSWERED,
  ADD_MESSAGE_FROM_BACKEND,
  GET_FLAGGED_QUESTIONS,
  DELETE_QUESTIONS,
  UNFLAG_QUESTIONS,
  GET_DELETED_QUESTIONS,
  RESTORE_QUESTIONS,
  GET_AVAILABLE_QUESTIONS,
  FETCH_QUESTIONS
}



// WEBPACK FOOTER //
// ./src/app/reducers/constants/questionConstants.js